/**
 * K线底部装饰器
 */
import FootDectorator from '../footdectorator';
import Util,{mergeModelData} from '../../../util/index.js';
const model = {
  kline: {
    Type: Array,
    Default: () => ([])
  }
};
const KLineFootDectorator = BaseClass => class extends FootDectorator(BaseClass) {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
    this.maxValue1 = undefined;
    this.minValue1 = undefined
  }
  _drawAxisX() {
    const {
      top,
      isFullScreen,
    } = this.state;
    const {period, min_time, start,len,kline,end} = this.state.data;
    const {
      width,
      left,
      height,
      barSpace,
      barWidth,
      bottom,
      height1
    } = this.availArea;
    if (!this.option.FootContext.axisX) {
      // 指标分离时不需要展示坐标轴 此处做特殊处理
      return
    }
    const {
      top: topRatio,
      sizeRatio,
      fontFamily,
      color
    } = !isFullScreen ? this.option.FootContext.axisX : this.option.FootContext.fullAxisX;
    const {dashColor, solidColor} = this.option.FootContext;
    const ctx = this.context;
    ctx.font = sizeRatio * this.state.baseSize * this.dpr + "px " + fontFamily;
    ctx.textBaseline = "top";
    ctx.fillStyle = color;
    const perWidth = barSpace + barWidth; // 每两个时间之间的距离
    const topY = top + height * topRatio;
    let validArr = min_time.slice(start) // 当前展示时间段
    if(validArr.length==0){
      return;
    }
    let num = 5,forData=null;
    let firstDayInMonth = [],dayData = [],firstYear=[];
    let currMonth = validArr[0].toString().substr(4,2)
    let currData = validArr[0].toString().substr(4,4)
    let currYear = validArr[0].toString().substr(0,4)
    validArr.forEach(element => {
      let year = element.toString().substr(0,4)
      let month = element.toString().substr(4,2)
      let day = element.toString().substr(4,4)
      if (month != currMonth) {
        firstDayInMonth.push(element)
        currMonth = month
      }
      if (day != currData) {
        dayData.push(element)
        currData = day
      }
      if (year != currYear) {
        firstYear.push(element)
        currYear = year
      }
    });
    const firstYearLen = firstYear.length
    const firstLen = firstDayInMonth.length
    const multiple = parseInt((firstYearLen/12))+1
    if(firstYear.length<=1){
      firstYear.unshift(validArr[0])
    }
    if(firstDayInMonth.length==0){
      firstDayInMonth.unshift(validArr[0])
    }
    if(dayData.length==0){
      dayData.unshift(validArr[0])
    }
    switch(period) {
      // 15分
      case 3:
        dayData.forEach((ele,index) => {
          let min = ele.toString().substr(-4)
          let leftX = validArr.indexOf(ele) * perWidth + barWidth/2 + left
          // if(index!=0&&index!=dayData.length-1){
          const realIndex = validArr.indexOf(ele)
          const kData = kline[start+realIndex];
          ele = ele.toString()
          if(kData){
            const high = kData.kHeight.find(a => a.key === 'high_px').lineY;
            const low = kData.kHeight.find(a => a.key === 'low_px').lineY;
            this._drawDash({x:leftX, y: top}, {x:leftX, y: top - low}, this.dpr * 0.2 , dashColor);
            this._drawDash({x:leftX, y: top - high}, {x:leftX, y: 0}, this.dpr * 0.2 , dashColor);
            ctx.textAlign = 'center'
          }
          if(index == 0) {
            ctx.textAlign = "left"
          }else if(index == dayData.length-1){
            ctx.textAlign = "right"
          }else {
            ctx.textAlign = "center"
          }
          ctx.fillText(`${ele.substr(0,4)}-${ele.substr(4,2)}-${ele.substr(6,2)}`, leftX, topY);
          // }
        })
        break;
      // 30分
      case 4:
        dayData.forEach((ele,index) => {
          // if(dayData.length>=10&&(index==0||index==dayData.length-1)){
          //   return
          // }
          if(index%2==0){
            return
          }
          let min = ele.toString().substr(-4)
          let leftX = validArr.indexOf(ele) * perWidth + barWidth/2 + left
          // if(index!=0&&index!=dayData.length-1){
          const realIndex = validArr.indexOf(ele)
          const kData = kline[start+realIndex];
          ele = ele.toString()
          if(kData){
            const high = kData.kHeight.find(a => a.key === 'high_px').lineY;
            const low = kData.kHeight.find(a => a.key === 'low_px').lineY;
            this._drawDash({x:leftX, y: top}, {x:leftX, y: top - low}, this.dpr * 0.2 , dashColor);
            this._drawDash({x:leftX, y: top - high}, {x:leftX, y: 0}, this.dpr * 0.2 , dashColor);
            ctx.textAlign = 'center'
          }
          if(index == 0) {
            ctx.textAlign = "left"
          }else if(index == dayData.length-1){
            ctx.textAlign = "right"
          }else {
            ctx.textAlign = "center"
          }
          ctx.textAlign = "center"
          ctx.fillText(`${ele.substr(0,4)}-${ele.substr(4,2)}-${ele.substr(6,2)}`, leftX, topY);
          // }
        })
        break;
      // 60分4天一个点
      case 5:
        dayData.forEach((ele,index) => {
          if(index%5 != 0){
            return
          }
          let leftX = validArr.indexOf(ele) * perWidth + barWidth/2 + left
          const realIndex = validArr.indexOf(ele)
          const kData60 = kline[start+realIndex];
          if(kData60){
            const high = kData60.kHeight.find(a => a.key === 'high_px').lineY;
            const low = kData60.kHeight.find(a => a.key === 'low_px').lineY;
            this._drawDash({x:leftX, y: top}, {x:leftX, y: top - low}, this.dpr * 0.2 , dashColor);
            this._drawDash({x:leftX, y: top - high}, {x:leftX, y: 0}, this.dpr * 0.2 , dashColor);
            ctx.textAlign = 'center'
          }
          ele = ele.toString()
          if(index == 0) {//简单解决第一个被排除的情况
            ctx.textAlign = "left"
          }else if(index == firstDayInMonth.length-1){
            ctx.textAlign = "right"
          }else {
            ctx.textAlign = "center"
          }
          ctx.fillText(`${ele.substr(0,4)}-${ele.substr(4,2)}-${ele.substr(6,2)}`, leftX, topY);
        })
        break;
      // 1分 每半小时1个点
      case 1:
        validArr.forEach((ele,index) => {
          let min = ele.toString().substr(-2)
          // console.log(ele.toString().substr(-2),ele)
          // if (min=='1030'||min=='1130'||min=='1400'||min=='1500'||min=='1600') {
          if (min=='00'||min=='30') {
            ele = ele.toString()
            let leftX = index * perWidth + barWidth/2 + left
            // if(index != 0 && index != validArr.length-1) {
              // this._drawSolid({x: leftX, y: top}, {x: leftX, y: 0}, this.dpr * 0.2, solidColor,ctx)
              const kData = kline[start+index];
              if(kData){
                const high = kData.kHeight.find(a => a.key === 'high_px').lineY;
                const low = kData.kHeight.find(a => a.key === 'low_px').lineY;
                this._drawDash({x:leftX, y: top}, {x:leftX, y: top - low}, this.dpr * 0.2 , dashColor);
                this._drawDash({x:leftX, y: top - high}, {x:leftX, y: 0}, this.dpr * 0.2 , dashColor);
                ctx.textAlign = 'center'
              }
            // }
            if(index == 0){
              ctx.textAlign = "left"
            }else if(index == validArr.length-1) {
              ctx.textAlign = "right"
            }else {
              ctx.textAlign = "center"
            }
            ctx.fillText(`${ele.substr(8,2)}:${ele.substr(-2)}`, leftX, topY);
          }
        })
        break;
      // 5分
      case 2:
        // 1分 每半小时1个点
        validArr.forEach((ele,index) => {
          let min = ele.toString().substr(-4)
          if (min=='1030'||min=='1130'||min=='1400'||min=='1500'||min=='1600') {
            ele = ele.toString()
            let leftX = index * perWidth + barWidth/2 + left
            // if(index != 0 && index != validArr.length-1) {
              // this._drawSolid({x: leftX, y: top}, {x: leftX, y: 0}, this.dpr * 0.2, solidColor,ctx)
              const kData = kline[start+index];
              if(kData){
                const high = kData.kHeight.find(a => a.key === 'high_px').lineY;
                const low = kData.kHeight.find(a => a.key === 'low_px').lineY;
                this._drawDash({x:leftX, y: top}, {x:leftX, y: top - low}, this.dpr * 0.2 , dashColor);
                this._drawDash({x:leftX, y: top - high}, {x:leftX, y: 0}, this.dpr * 0.2 , dashColor);
                ctx.textAlign = 'center'
              }
            // }
            if(index == 0){
              ctx.textAlign = "left"
            }else if(index == validArr.length-1) {
              ctx.textAlign = "right"
            }else {
              ctx.textAlign = "center"
            }
            ctx.fillText(`${ele.substr(8,2)}:${ele.substr(-2)}`, leftX, topY);
          }
        })
        break;
      // 日k 取开始、结束及中间每个月第一个交易日
      case 6:
        forData = firstLen<=12?firstDayInMonth:firstYear
        forData.forEach((ele,index) => {
          let leftX = validArr.indexOf(ele) * perWidth + barWidth/2 + left
          // if (firstLen<=12&&firstLen!=1&&(index==0 || index == firstDayInMonth.length-1)){
          //   return;
          // }
          if (firstYearLen>12&&(index%(multiple)!=1)){
            return;
          }
          const realIndex = validArr.indexOf(ele)
          const kDataMonth = kline[start+realIndex];
          if(kDataMonth){
            const high = kDataMonth.kHeight.find(a => a.key === 'high_px').lineY;
            const low = kDataMonth.kHeight.find(a => a.key === 'low_px').lineY;
            this._drawDash({x:leftX, y: top}, {x:leftX, y: top - low}, this.dpr * 0.2 , dashColor);
            this._drawDash({x:leftX, y: top - high}, {x:leftX, y: 0}, this.dpr * 0.2 , dashColor);
          }
          // this._drawSolid({x: leftX, y: top}, {x: leftX, y: 0}, this.dpr * 0.2, solidColor,ctx)
          ele = ele.toString()
          if(index == 0){
            ctx.textAlign = "left"
          }else if(index == firstDayInMonth.length-1) {
            ctx.textAlign = "right"
          }
          else {
            ctx.textAlign = "center"
          }
          ctx.fillText(`${ele.substr(0,4)}${firstLen>12?'':'-'+ele.substr(4,2)}${firstLen<8?'-'+ele.substr(6,2):''}`, leftX, topY);
          return;
        });
        break;
      // 年k 规则未定，最小单位年
      case 9:
        firstYear.forEach((ele,index) => {
          if(end>50&&index%4!=1&&firstYearLen>1){
            return
          }
          if(index%2==0&&firstYearLen>1){
            return
          }
          let leftX = validArr.indexOf(ele) * perWidth + barWidth/2 + left
          const realIndex = validArr.indexOf(ele)
          const kDataMonth = kline[start+realIndex];
          if(kDataMonth){
            const high = kDataMonth.kHeight.find(a => a.key === 'high_px').lineY;
            const low = kDataMonth.kHeight.find(a => a.key === 'low_px').lineY;
            this._drawDash({x:leftX, y: top}, {x:leftX, y: top - low}, this.dpr * 0.2 , dashColor);
            this._drawDash({x:leftX, y: top - high}, {x:leftX, y: 0}, this.dpr * 0.2 , dashColor);
          }
          ele = ele.toString();
          if(index == 0){
            ctx.textAlign = "left"
          }else if(index == firstYear.length-1) {
            ctx.textAlign = "right"
          } else {
            ctx.textAlign = "center"
          }
          ctx.fillText(`${ele.substr(0,4)}`, leftX, topY);
          // ctx.fillText(`${ele.substr(0,4)}-${ele.substr(4,2)}`, leftX, topY);
        })
        break;
      //月k规则未定，最小单位月
      case 8:
        forData = firstLen<=80?firstDayInMonth:firstYear
        forData.forEach((ele,index) => {
          let leftX = validArr.indexOf(ele) * perWidth + barWidth/2 + left
          if (firstLen!=1&&(index==0 || index == firstDayInMonth.length-1)){
            return;
          }
          if(firstLen<=80&&index%6!=1){
            return
          }
          if(index!=0&&firstYearLen>=12&&index%2!=1){
            return
          }
          const realIndex = validArr.indexOf(ele)
          const kDataMonth = kline[start+realIndex];
          if(kDataMonth){
            const high = kDataMonth.kHeight.find(a => a.key === 'high_px').lineY;
            const low = kDataMonth.kHeight.find(a => a.key === 'low_px').lineY;
            this._drawDash({x:leftX, y: top}, {x:leftX, y: top - low}, this.dpr * 0.2 , dashColor);
            this._drawDash({x:leftX, y: top - high}, {x:leftX, y: 0}, this.dpr * 0.2 , dashColor);
          }
          // this._drawSolid({x: leftX, y: top}, {x: leftX, y: 0}, this.dpr * 0.2, solidColor,ctx)
          ele = ele.toString()
          if(index == 0||index==1){
            ctx.textAlign = "left"
          }else if(index == firstDayInMonth.length-1) {
            ctx.textAlign = "right"
          }
          else {
            ctx.textAlign = "center"
          }
          ctx.fillText(`${ele.substr(0,4)}${firstLen<=80?'-'+ele.substr(4,2):''}`, leftX, topY);
          return;
        });
        break;
      //周k规则未定，默认5根线画一个点
      case 7:
        forData = firstLen<=36?firstDayInMonth:firstYear
        firstLen<36?num=4:num=2//小于36个月每4个月画一个点显示年月日大于36个月每2年画一个点
        forData.forEach((ele,index) => {
          let leftX = validArr.indexOf(ele) * perWidth + barWidth/2 + left
          if (firstLen<36&&firstLen!=1&&(index==0 || index == firstDayInMonth.length-1)){
            return;
          }
          if (index!=0&&firstLen<36&&index%num != 1){
            return;
          }
          if (firstYearLen>6&&index%(multiple*num) != 1){
            return;
          }
          const realIndex = validArr.indexOf(ele)
          const kDataMonth = kline[start+realIndex];
          if(kDataMonth){
            const high = kDataMonth.kHeight.find(a => a.key === 'high_px').lineY;
            const low = kDataMonth.kHeight.find(a => a.key === 'low_px').lineY;
            this._drawDash({x:leftX, y: top}, {x:leftX, y: top - low}, this.dpr * 0.2 , dashColor);
            this._drawDash({x:leftX, y: top - high}, {x:leftX, y: 0}, this.dpr * 0.2 , dashColor);
          }
          // this._drawSolid({x: leftX, y: top}, {x: leftX, y: 0}, this.dpr * 0.2, solidColor,ctx)
          ele = ele.toString()
          if(index == 0||index==1){
            ctx.textAlign = "left"
          }else if(index == firstDayInMonth.length-1) {
            ctx.textAlign = "right"
          }
          else {
            ctx.textAlign = "center"
          }
          ctx.fillText(`${ele.substr(0,4)}${firstLen>36?'':'-'+ele.substr(4,2)}${firstLen<30?'-'+ele.substr(6,2):''}`, leftX, topY);
          return;
        });
        break;
      default:
        break;
    }
  }
  _calcRange() {
    super._calcRange()
    let maxValue,minValue;
    let { start, end, kline } = this.state.data;
    const getArrayValue = (a,targetKey) => {
      if(!targetKey){
        const _maxValue = Math.max.apply(null, a.slice(start, end));
        const _minValue = Math.min.apply(null, a.slice(start, end));
        maxValue = Math.max(maxValue, _maxValue);
        minValue = Math.min(minValue, _minValue);
        return
      }
      const arrayData = a.slice(start, end).map(b => b[targetKey]).filter(c => Util.isValidNumber(c));
      const _minValue = Math.min.apply(null, arrayData);
      const _maxValue = Math.max.apply(null, arrayData);
      if (Util.isValidNumber(_maxValue)) {
        if (Util.isValidNumber(maxValue)) {
          maxValue = Math.max(maxValue, _maxValue);
        } else {
          maxValue = _maxValue;
        }
      }
      if (Util.isValidNumber(_minValue)) {
        if (Util.isValidNumber(minValue)) {
          minValue = Math.min(minValue, _minValue);
        } else {
          minValue = _minValue;
        }
      }
    }
    // const klineData = kline.slice(start, end);
    const highList = kline.map(a => a.high_px);
    const lowList = kline.map(a => a.low_px);
    const openList = kline.map(a => a.open_px);
    const closeList = kline.map(a => a.close_px);
    const precloseList = kline.map(a => a.preclose_px);
    const { maData } = this.store.state
    Object.values(maData).forEach(function (value) {
      getArrayValue(value,'close_px')
    })

    getArrayValue(highList)
    getArrayValue(lowList)
    // getArrayValue(openList,'open_px')
    // getArrayValue(closeList,'close_px')
    // getArrayValue(precloseList,'preclose_px')
    this.maxValue1 = maxValue;
    this.minValue1 = minValue;
  }
  _calcAxis() {
    super._calcAxis()
    const {kline, start, end} = this.state.data;
    const {
      height1,
    } = this.availArea;
    const minValue = this.minValue1;
    const range = this.maxValue1 - this.minValue1;
    const ratio = height1 / range;
    const len = Math.min(end, kline.length);
    for (let i = start; i < len; i++) {
      const kHeight = [];
      const kData = kline[i];
      ['high_px', 'low_px'].forEach(key => {
        kHeight.push({key, lineY: (kData[key] - minValue) * ratio});
      });
      kData.kHeight = kHeight;
    }
  }
  // _calcCursorAxis(index) {
  //   const {kline, start} = this.state.data;
  //   /*** 绘制Y轴标签 ***/
  //   const data = kline[index];
  //   if (data) {
  //     const close_px = data.kHeight.find(a => a.key === 'close_px');
  //     const high = data.kHeight.find(a => a.key === 'high_px').lineY;
  //     const low = data.kHeight.find(a => a.key === 'low_px').lineY;
  //     // const height=(high-low).toFixed(0)
  //     if (close_px) {
  //       const text = data.close_px;
  //       const y = close_px.lineY;
  //       return {text, y,high,low}
  //     }
  //   }
  // }
}
export default KLineFootDectorator;
